export { useAutoLikeComment } from './useAutoLikeComment';
